import tracker from '@tcc/analytics';

function generateRandomId() {
  var randomArray = Math.random().toString(36).substr(2, 13).split('');

  var newArray = randomArray.map((a) => {
    if (isNaN(a)) {
      return Math.floor(Math.random() * 2) ? a : a.toUpperCase();
    }
    return a;
  });

  return newArray.join('');
}

export const sessionRandomId = generateRandomId();

export function initializeAnalytics() {
  tracker.segmentio.initializeSegment(sessionRandomId);
}

export function trackLogin() {
  tracker.segmentio.trackAction('Navigation', {
    'type': 'login'
  });
}

export function trackLogout() {
  tracker.segmentio.trackAction('Navigation', {
    'type': 'logout'
  });
}

export function trackGetAuthToken() {
  tracker.segmentio.trackAction('Navigation', {
    'type': 'get-auth-token'
  });
}

export function trackAutoLoginSuccess() {
  // tracker.segmentio.trackAction('Login: Active session cookie');
}

export function trackAutoLoginFailure() {
  // tracker.segmentio.trackAction('Login: No active session cookie');
}

export function trackIncorrectEmailOrPassword() {
  // tracker.segmentio.trackAction('Login: Incorrect email or password');
}

export function trackStayLoggedInSelected() {
  // tracker.segmentio.trackAction('Login: Stay logged in selected');
}

export function trackLoginSuccess() {
  // tracker.segmentio.trackAction('Login: Login success', {
  //   time
  // });
}

export function trackClickResetPassword() {
  // tracker.segmentio.trackAction('Login: Clicked on reset password link');
}

export function trackClickRegistration() {
  // tracker.segmentio.trackAction('Login: Clicked on registration link');
}
